module.exports = __webpack_public_path__ + "static/media/mett.c2c39d81.png";